import { useActivityShowContext } from "PFApp/activities/show/context/activity_show_context";
import { ProfilesListMode } from "PFApp/activities/types/profiles_view_mode";
import { Icon } from "PFComponents/icon";
import { MultiToggle } from "PFComponents/multi_toggle";

const modeOptions = [
  {
    id: ProfilesListMode.Cards,
    value: <Icon name="note" size="sm" />
  },
  {
    id: ProfilesListMode.Table,
    value: <Icon name="list" size="sm" />
  }
];

export const ProfileViewModeToggle = () => {
  const { profilesListMode, setProfilesListMode } = useActivityShowContext();

  return (
    <MultiToggle<ProfilesListMode>
      controlledValue={profilesListMode}
      options={modeOptions}
      onChange={setProfilesListMode}
    />
  );
};
